var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockDrawing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C5.23858 0 3 2.23858 3 5V9H6V5C6 3.5 7 3 8 3H12C13 3 14 3.34315 14 5V9H17V5C17 2.23858 14.7614 0 12 0H8Z",
    fill: "#414042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11C0 9.89543 0.895431 9 2 9H18C19.1046 9 20 9.89543 20 11V22C20 23.1046 19.1046 24 18 24H2C0.895431 24 0 23.1046 0 22V11ZM11 16.7324C11.5978 16.3866 12 15.7403 12 15C12 13.8954 11.1046 13 10 13C8.89543 13 8 13.8954 8 15C8 15.7403 8.4022 16.3866 9 16.7324V20H11V16.7324Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockDrawing);
export default __webpack_public_path__ + "static/media/LockDrawing.8ad830b6d47c4f2c3346510da3b3d00c.svg";
export { ForwardRef as ReactComponent };